import axiosInstance from "axiosConfig";

const getPerformanceData = async () => {
  try {
    const { data } = await axiosInstance.get("/api/us-performance/");
    console.log("performance", data);
    return data;
  } catch (error) {
    console.error("Error fetching performance data:", error);
    return null;
  }
};

const performanceService = {
  getPerformanceData,
};

export default performanceService;
